// src/components/OurServices.js

import React from 'react';
import Slider from 'react-slick';
import heritageAirportImg from '../assets/images/HeritageCarAirport.jpg';
import heritageMKTImg from '../assets/images/HeritageMKT.jpg';
import escaladeImg from '../assets/images/Escalade1.jpg';
import mkt1Img from '../assets/images/MKT1.jpg';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const OurServices = () => {
  // Configuración del carrusel (mostrar 1 tarjeta a la vez)
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
  };

  const servicesData = [
    {
      image: heritageAirportImg,
      title: 'Heritage Car Airport',
      description:
        'Arrive in timeless elegance with our Heritage Car Airport service—classic charm and modern luxury combined.',
      contactLink: 'tel:8452258191',
      contactLabel: 'Call Now',
    },
    {
      image: heritageMKTImg,
      title: 'Lincoln MKT',
      description:
        'Experience superior comfort and style in our Lincoln MKT—ideal for business trips, special events, and leisurely journeys.',
      contactLink: 'sms:8452258191?body=Hello',
      contactLabel: 'Text Message',
    },
    {
      image: escaladeImg,
      title: 'Out of Town',
      description:
        'Embark on safe, reliable long-distance rides—perfect for spontaneous getaways and extended travel.',
      contactLink: 'mailto:GOHERITAGELIMO@gmail.com',
      contactLabel: 'Email Us',
    },
    {
      image: mkt1Img,
      title: 'Corporate Travel',
      description:
        'Discover efficient transportation solutions designed for busy executives on the move.',
      contactLink: 'https://wa.me/18452258191',
      contactLabel: 'WhatsApp Chat',
    },
  ];

  const styles = {
    ourServicesSection: {
      padding: '20px',
      marginTop: '50px',
      backgroundColor: '#fff',
      textAlign: 'center',
    },
    ourServicesTitle: {
      fontSize: '28px',
      fontWeight: '600',
      marginBottom: '10px',
    },
    ourServicesSubtitle: {
      fontSize: '17px',
      color: '#6b7280',
      marginBottom: '30px',
    },
    card: {
      borderRadius: '12px',
      boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
      margin: '20px',
    },
    imageWrapperCard: {
      overflow: 'hidden',
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
    },
    cardImage: {
      width: '100%',
      height: '350px',
      objectFit: 'cover',
      transition: 'transform 0.4s ease',
    },
    cardTitle: {
      fontSize: '22px',
      margin: '15px 0 5px',
      color: '#374151',
    },
    cardDescription: {
      fontSize: '16px',
      color: '#4b5563',
      margin: '0 15px 15px',
      textAlign: 'left',
    },
    singleButtonContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '15px',
    },
    singleContactButton: {
      background: 'linear-gradient(45deg, #3b82f6, #60a5fa)',
      color: '#fff',
      padding: '12px 24px',
      borderRadius: '8px',
      textDecoration: 'none',
      fontSize: '16px',
      transition: 'background 0.3s ease, transform 0.3s ease',
      boxShadow: '0 6px 12px rgba(0,0,0,0.2)',
    },
  };

  return (
    <section style={styles.ourServicesSection}>
      <h2 style={styles.ourServicesTitle}>Explore Our Services</h2>
      <p style={styles.ourServicesSubtitle}>
        Choose from a variety of premium services tailored to your needs
      </p>
      <Slider {...sliderSettings}>
        {servicesData.map((service, index) => (
          <div
            key={index}
            style={styles.card}
            onMouseEnter={(e) => {
              const img = e.currentTarget.querySelector('img');
              if (img) img.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              const img = e.currentTarget.querySelector('img');
              if (img) img.style.transform = 'scale(1)';
            }}
            itemScope
            itemType="http://schema.org/Service"
          >
            <div style={styles.imageWrapperCard}>
              <img
                src={service.image}
                alt={service.title}
                style={styles.cardImage}
                itemProp="image"
              />
            </div>
            <h2 style={styles.cardTitle} itemProp="name">
              {service.title}
            </h2>
            <p style={styles.cardDescription} itemProp="description">
              {service.description}
            </p>
            <div style={styles.singleButtonContainer}>
              <a
                style={styles.singleContactButton}
                href={service.contactLink}
                itemProp="url"
              >
                {service.contactLabel}
              </a>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default OurServices;
